/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CategoryDTO {
  /** @format int64 */
  id?: number;
  name?: CategoryDtoNameEnum;
  groupName?: CategoryDtoGroupNameEnum;
}

export interface DraftBusinessDetailsDTO {
  /** @format int64 */
  id?: number;
  name?: string;
  shortDescription?: string;
  address?: string;
  email?: string;
  phone?: string;
  languages?: LanguageDTO[];
  logoUrl?: string;
  category?: CategoryDTO;
  portfolio?: PortfolioDTO[];
  longDescription?: string;
  staff?: StaffDTO[];
  /** @format int64 */
  draftBusinessId?: number;
}

export interface LanguageDTO {
  /** @format int64 */
  id?: number;
  name?: string;
  code?: string;
}

export interface PortfolioDTO {
  /** @format int64 */
  id?: number;
  url?: string;
}

export interface PriceDTO {
  /** @format int64 */
  id?: number;
  currency?: PriceDtoCurrencyEnum;
  value?: number;
  discountValue?: number;
}

/** Services */
export interface ServiceInstanceDTO {
  /** @format int64 */
  id?: number;
  customName?: string;
  description?: string;
  price?: PriceDTO;
  serviceType?: ServiceTypeDTO;
}

export interface ServiceTypeDTO {
  /** @format int64 */
  id?: number;
  name?: string;
}

export interface StaffDTO {
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * Full Name
   * @example "Yakub Kolas"
   */
  fullName: string;
  /** Photo Url */
  photoUrl?: string;
  /** Services */
  services: ServiceInstanceDTO[];
}

export interface ModerationDecisionDTO {
  status?: ModerationDecisionDtoStatusEnum;
  /** comment why rejected or approved */
  comment?: string | null;
}

export interface BusinessDTO {
  /** @format int64 */
  id?: number;
  name?: string;
  shortDescription?: string;
  address?: string;
  email?: string;
  phone?: string;
  languages?: LanguageDTO[];
  logoUrl?: string;
  category?: CategoryDTO;
  portfolio?: PortfolioDTO[];
}

export interface BusinessDetailsDTO {
  /** @format int64 */
  id?: number;
  name?: string;
  shortDescription?: string;
  address?: string;
  email?: string;
  phone?: string;
  languages?: LanguageDTO[];
  logoUrl?: string;
  category?: CategoryDTO;
  portfolio?: PortfolioDTO[];
  longDescription?: string;
  staff?: StaffDTO[];
}

export interface Language {
  /** @format int64 */
  id?: number;
  name?: string;
  code?: string;
}

export interface CityDTO {
  /** @format int64 */
  id?: number;
  name?: string;
}

export interface CountryDTO {
  /** @format int64 */
  id?: number;
  name?: string;
  cities?: CityDTO[];
}

export interface PageBusinessDTO {
  /** @format int32 */
  totalPages?: number;
  /** @format int64 */
  totalElements?: number;
  pageable?: PageableObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int32 */
  size?: number;
  content?: BusinessDTO[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  unpaged?: boolean;
  /** @format int32 */
  pageNumber?: number;
  paged?: boolean;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  offset?: number;
  sort?: SortObject[];
}

export interface SortObject {
  direction?: string;
  nullHandling?: string;
  ascending?: boolean;
  property?: string;
  ignoreCase?: boolean;
}

export interface BusinessWithServicesDTO {
  /** @format int64 */
  id?: number;
  name?: string;
  shortDescription?: string;
  address?: string;
  email?: string;
  phone?: string;
  languages?: LanguageDTO[];
  logoUrl?: string;
  category?: CategoryDTO;
  portfolio?: PortfolioDTO[];
  services?: ServiceInstanceDTO[];
}

export interface PageBusinessWithServicesDTO {
  /** @format int32 */
  totalPages?: number;
  /** @format int64 */
  totalElements?: number;
  pageable?: PageableObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int32 */
  size?: number;
  content?: BusinessWithServicesDTO[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface PageDraftBusinessDetailsDTO {
  /** @format int32 */
  totalPages?: number;
  /** @format int64 */
  totalElements?: number;
  pageable?: PageableObject;
  /** @format int32 */
  numberOfElements?: number;
  /** @format int32 */
  size?: number;
  content?: DraftBusinessDetailsDTO[];
  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface ClerkUser {
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  imageUrl?: string;
  roles?: string[];
  emailVerified?: boolean;
}

export interface BookingDTO {
  /** @format int64 */
  id?: number;
  clientName?: string;
  clientPhone?: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  note?: string;
  status?: BookingDtoStatusEnum;
}

export enum CategoryDtoNameEnum {
  BARBERS = "BARBERS",
  HAIR_STYLISTS = "HAIR_STYLISTS",
  BROW_AND_LASH_ARTISTS = "BROW_AND_LASH_ARTISTS",
  NAIL_TECHNICIANS = "NAIL_TECHNICIANS",
  TUTORS_SCHOOL_UNIVERSITY = "TUTORS_SCHOOL_UNIVERSITY",
  LANGUAGE_TEACHERS = "LANGUAGE_TEACHERS",
  MUSIC_INSTRUCTORS = "MUSIC_INSTRUCTORS",
  ART_DRAWING_TEACHERS = "ART_DRAWING_TEACHERS",
  TEST_PREP_COACHES_SAT_IELTS = "TEST_PREP_COACHES_SAT_IELTS",
  MASSAGE_THERAPISTS = "MASSAGE_THERAPISTS",
  PERSONAL_TRAINERS = "PERSONAL_TRAINERS",
  YOGA_PILATES_INSTRUCTORS = "YOGA_PILATES_INSTRUCTORS",
  NUTRITIONISTS = "NUTRITIONISTS",
  PHYSICAL_THERAPISTS = "PHYSICAL_THERAPISTS",
  CLEANING_SERVICES = "CLEANING_SERVICES",
  HOME_ORGANIZERS = "HOME_ORGANIZERS",
  REPAIRMEN_HANDYMEN = "REPAIRMEN_HANDYMEN",
  TAILORS_SEWING = "TAILORS_SEWING",
  PHOTOGRAPHERS = "PHOTOGRAPHERS",
  VIDEOGRAPHERS = "VIDEOGRAPHERS",
  EVENT_PLANNERS = "EVENT_PLANNERS",
  DJS_HOSTS = "DJS_HOSTS",
  DECORATORS = "DECORATORS",
  DOG_WALKERS = "DOG_WALKERS",
  PET_GROOMERS = "PET_GROOMERS",
  TRAINERS = "TRAINERS",
  SITTERS = "SITTERS",
  FREELANCE_DESIGNERS = "FREELANCE_DESIGNERS",
  DEVELOPERS = "DEVELOPERS",
  MARKETING_CONSULTANTS = "MARKETING_CONSULTANTS",
  VIRTUAL_ASSISTANTS = "VIRTUAL_ASSISTANTS",
  RESUME_WRITERS = "RESUME_WRITERS",
}

export enum CategoryDtoGroupNameEnum {
  BEAUTY = "BEAUTY",
  EDUCATION = "EDUCATION",
  HEALTH_AND_WELLNESS = "HEALTH_AND_WELLNESS",
  HOME_AND_LIFESTYLE = "HOME_AND_LIFESTYLE",
  EVENTS_AND_CREATIVE = "EVENTS_AND_CREATIVE",
  PET_SERVICES = "PET_SERVICES",
  BUSINESS_AND_TECH = "BUSINESS_AND_TECH",
}

export enum PriceDtoCurrencyEnum {
  PLN = "PLN",
  USD = "USD",
  EUR = "EUR",
}

export enum ModerationDecisionDtoStatusEnum {
  AWAITING_APPROVAL = "AWAITING_APPROVAL",
  APPROVED = "APPROVED",
  DRAFT = "DRAFT",
  REJECTED = "REJECTED",
  APPROVED1 = "APPROVED",
  REJECTED2 = "REJECTED",
}

export enum BookingDtoStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

/** @format int64 */
export type WithdrawDraftBusinessPayload = number;

export interface UploadStaffImagePayload {
  /** @format binary */
  file: File;
}

export interface UploadPortfolioImagePayload {
  /** @format binary */
  file: File;
}

export interface UploadLogoImagePayload {
  /** @format binary */
  file: File;
}

export interface UploadStaffImage1Payload {
  /** @format binary */
  file: File;
}

export interface UploadPortfolioImage1Payload {
  /** @format binary */
  file: File;
}

export interface UploadLogoImage1Payload {
  /** @format binary */
  file: File;
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl /
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  draftBusiness = {
    /**
     * No description
     *
     * @tags draft-business
     * @name UpdateDraftBusiness
     * @request PUT:/business-api/draft/businesses
     */
    updateDraftBusiness: (data: DraftBusinessDetailsDTO, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/business-api/draft/businesses`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft-business
     * @name CreateDraftBusiness
     * @request POST:/business-api/draft/businesses
     */
    createDraftBusiness: (data: BusinessDTO, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/business-api/draft/businesses`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft-business
     * @name WithdrawDraftBusiness
     * @request POST:/business-api/draft/businesses/withdraw
     */
    withdrawDraftBusiness: (data: WithdrawDraftBusinessPayload, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/business-api/draft/businesses/withdraw`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft-business
     * @name PublishDraftBusiness
     * @request POST:/business-api/draft/businesses/publish/{draftBusinessId}
     */
    publishDraftBusiness: (draftBusinessId: number, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/business-api/draft/businesses/publish/${draftBusinessId}`,
        method: "POST",
        ...params,
      }),
  };
  moderation = {
    /**
     * No description
     *
     * @tags moderation
     * @name ProcessModerationDecision
     * @request POST:/business-api/moderation/process/{id}
     */
    processModerationDecision: (id: number, data: ModerationDecisionDTO, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/business-api/moderation/process/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags moderation
     * @name GetAllForModeration
     * @request GET:/business-api/moderation
     */
    getAllForModeration: (
      query?: {
        /**
         * Zero-based page index (0..N)
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * The size of the page to be returned
         * @min 1
         * @default 20
         */
        size?: number;
        /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
        sort?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageDraftBusinessDetailsDTO, any>({
        path: `/business-api/moderation`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  business = {
    /**
     * No description
     *
     * @tags business
     * @name EditBusiness
     * @request POST:/business-api/businesses/edit
     */
    editBusiness: (data: BusinessDetailsDTO, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/business-api/businesses/edit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  draftBusinessImage = {
    /**
     * No description
     *
     * @tags draft-business-image
     * @name UploadStaffImage
     * @request POST:/api/draft/businesses/{draftBusinessId}/images/staff
     */
    uploadStaffImage: (draftBusinessId: number, data: UploadStaffImagePayload, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/draft/businesses/${draftBusinessId}/images/staff`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft-business-image
     * @name UploadPortfolioImage
     * @request POST:/api/draft/businesses/{draftBusinessId}/images/portfolio
     */
    uploadPortfolioImage: (draftBusinessId: number, data: UploadPortfolioImagePayload, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/draft/businesses/${draftBusinessId}/images/portfolio`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft-business-image
     * @name UploadLogoImage
     * @request POST:/api/draft/businesses/{draftBusinessId}/images/logo
     */
    uploadLogoImage: (draftBusinessId: number, data: UploadLogoImagePayload, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/draft/businesses/${draftBusinessId}/images/logo`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  businessImage = {
    /**
     * No description
     *
     * @tags business-image
     * @name UploadStaffImage1
     * @request POST:/api/businesses/{businessId}/images/staff
     */
    uploadStaffImage1: (businessId: number, data: UploadStaffImage1Payload, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/businesses/${businessId}/images/staff`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags business-image
     * @name UploadPortfolioImage1
     * @request POST:/api/businesses/{businessId}/images/portfolio
     */
    uploadPortfolioImage1: (businessId: number, data: UploadPortfolioImage1Payload, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/businesses/${businessId}/images/portfolio`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags business-image
     * @name UploadLogoImage1
     * @request POST:/api/businesses/{businessId}/images/logo
     */
    uploadLogoImage1: (businessId: number, data: UploadLogoImage1Payload, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/businesses/${businessId}/images/logo`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  language = {
    /**
     * No description
     *
     * @tags language
     * @name GetAll
     * @request GET:/public/api/languages
     */
    getAll: (params: RequestParams = {}) =>
      this.http.request<Language[], any>({
        path: `/public/api/languages`,
        method: "GET",
        ...params,
      }),
  };
  country = {
    /**
     * No description
     *
     * @tags country
     * @name GetCountries
     * @request GET:/public/api/countries
     */
    getCountries: (params: RequestParams = {}) =>
      this.http.request<CountryDTO[], any>({
        path: `/public/api/countries`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags country
     * @name GetCitiesByCountryId
     * @request GET:/public/api/countries/{id}/cities
     */
    getCitiesByCountryId: (id: number, params: RequestParams = {}) =>
      this.http.request<CityDTO[], any>({
        path: `/public/api/countries/${id}/cities`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags country
     * @name GetCountryCityMap
     * @request GET:/public/api/countries/city-map
     */
    getCountryCityMap: (params: RequestParams = {}) =>
      this.http.request<Record<string, string[]>, any>({
        path: `/public/api/countries/city-map`,
        method: "GET",
        ...params,
      }),
  };
  category = {
    /**
     * No description
     *
     * @tags category
     * @name GetAllCategories
     * @request GET:/public/api/categories
     */
    getAllCategories: (params: RequestParams = {}) =>
      this.http.request<CategoryDTO[], any>({
        path: `/public/api/categories`,
        method: "GET",
        ...params,
      }),
  };
  serviceType = {
    /**
     * No description
     *
     * @tags service-type
     * @name GetAllByCategoryId
     * @request GET:/public/api/categories/{categoryId}/service-types
     */
    getAllByCategoryId: (categoryId: number, params: RequestParams = {}) =>
      this.http.request<ServiceTypeDTO[], any>({
        path: `/public/api/categories/${categoryId}/service-types`,
        method: "GET",
        ...params,
      }),
  };
  publicBusiness = {
    /**
     * No description
     *
     * @tags public-business
     * @name GetAll1
     * @request GET:/public/api/businesses
     */
    getAll1: (
      query?: {
        categoryIds?: number[];
        serviceTypeIds?: number[];
        name?: string;
        /**
         * Zero-based page index (0..N)
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * The size of the page to be returned
         * @min 1
         * @default 20
         */
        size?: number;
        /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
        sort?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageBusinessDTO, any>({
        path: `/public/api/businesses`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags public-business
     * @name GetById
     * @request GET:/public/api/businesses/{id}
     */
    getById: (id: number, params: RequestParams = {}) =>
      this.http.request<BusinessDetailsDTO, any>({
        path: `/public/api/businesses/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public-business
     * @name GetAllByCategory
     * @request GET:/public/api/businesses/category/{id}
     */
    getAllByCategory: (
      id: number,
      query?: {
        /**
         * Zero-based page index (0..N)
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * The size of the page to be returned
         * @min 1
         * @default 20
         */
        size?: number;
        /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
        sort?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PageBusinessWithServicesDTO, any>({
        path: `/public/api/businesses/category/${id}`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags health
     * @name HealthCheck
     * @request GET:/health
     */
    healthCheck: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/health`,
        method: "GET",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags user
     * @name GetCurrentUser
     * @request GET:/api/user/me
     */
    getCurrentUser: (params: RequestParams = {}) =>
      this.http.request<ClerkUser, any>({
        path: `/api/user/me`,
        method: "GET",
        ...params,
      }),
  };
  booking = {
    /**
     * No description
     *
     * @tags booking
     * @name GetByStaff
     * @request GET:/api/bookings/staff/{staffId}
     */
    getByStaff: (staffId: number, params: RequestParams = {}) =>
      this.http.request<BookingDTO[], any>({
        path: `/api/bookings/staff/${staffId}`,
        method: "GET",
        ...params,
      }),
  };
}
